import React from 'react'

import { createValidIcon } from '@ui/icons/utils/type-helper'

export const PercentIcon = createValidIcon((props) => {
  const { size, color } = props

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M8.4376 5.69825C7.65779 4.91699 6.39424 4.91699 5.61443 5.69825C4.8336 6.48054 4.8336 7.74964 5.61443 8.53193C6.39424 9.31319 7.65779 9.31319 8.4376 8.53193C9.21844 7.74964 9.21844 6.48054 8.4376 5.69825ZM4.19891 4.28535C5.76007 2.72129 8.29197 2.72129 9.85313 4.28535C11.4133 5.84838 11.4133 8.3818 9.85313 9.94483C8.29197 11.5089 5.76007 11.5089 4.19891 9.94483C2.63878 8.3818 2.63878 5.84839 4.19891 4.28535ZM20.0545 4.0814C20.4451 4.47193 20.4451 5.10509 20.0545 5.49562L5.925 19.6252C5.53448 20.0157 4.90131 20.0157 4.51079 19.6252C4.12026 19.2346 4.12026 18.6015 4.51079 18.2109L18.6403 4.0814C19.0309 3.69088 19.664 3.69088 20.0545 4.0814ZM18.3857 15.4682C17.6059 14.6869 16.3423 14.6869 15.5625 15.4682C14.7817 16.2504 14.7817 17.5196 15.5625 18.3018C16.3423 19.0831 17.6059 19.0831 18.3857 18.3018C19.1665 17.5196 19.1665 16.2504 18.3857 15.4682ZM14.147 14.0553C15.7081 12.4912 18.24 12.4912 19.8012 14.0553C21.3613 15.6183 21.3613 18.1517 19.8012 19.7147C18.24 21.2788 15.7081 21.2788 14.147 19.7147C12.5868 18.1517 12.5868 15.6183 14.147 14.0553Z'
        fill={color}
      />
    </svg>
  )
})
